import moment from "moment";

function _getTypeName(text) {
  const typeName = {
    0: "通用",
    1: "班级",
    // 2: "活动"
  }
  return typeName[text];
}

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const columns = () => {
  return [
    {
      title: '安排名称',
      name: 'name',
      dataIndex: 'name',
      searchItem: {},
    },
    {
      title: '计划名称',
      name: 'name',
      dataIndex: 'name',
      tableItem: {
        width: 150
      }
    },
    {
      title: '计划安排类型',
      name: 'type',
      dataIndex: 'type',
      tableItem: {
        width: 250,
        render: (text) => {
          return _getTypeName(text)
        }
      }
    },
    {
      title: "计划安排时间",
      dataIndex: "applyPlanTime",
      name: "applyPlanTime",
      tableItem: {
        width: 250,
        render: (text, record) => {
          const {startTime, endTime} = record;
          return formatterDate(startTime) + " ~" + formatterDate(endTime)
        }
      }
    },
    {
      title: "地点",
      dataIndex: "address",
      name: "address",
      tableItem:{
        width: 200
      }
    },
    {
      title: "限制人数",
      dataIndex: "limitCount",
      name: "limitCount",
      tableItem:{
        width: 100
      }
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'applyPlan/listByPage',
    ...api
  }
};

const plan = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'planId',
    columns: columns(),
    tableApi: tableApi(api)
  }
};

export default plan
